export default "__VITE_ASSET__DxDOl261__"